import { render, staticRenderFns } from "./portal_Product-customization.vue?vue&type=template&id=573e0a38&scoped=true&"
import script from "./portal_Product-customization.vue?vue&type=script&lang=js&"
export * from "./portal_Product-customization.vue?vue&type=script&lang=js&"
import style0 from "./portal_Product-customization.vue?vue&type=style&index=0&id=573e0a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573e0a38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
